import { call, put, delay } from "redux-saga/effects";
import * as Api from "../../api";
import * as actions from "../actions";

// eslint-disable-next-line import/prefer-default-export
export function* onboardUpdateState(action) {
  yield put(actions.onboardLoadedState(action.progress));
}

export function* markDocumentRead({ payload }) {
  try {
    const filename = payload;
    yield call(Api.markDocumentRead, { document_read: filename });
  } catch (error) {
    yield put(actions.addError("Reading List", error));
  }
}

export function* reflexAllenFormSubmit({ payload }) {
  try {
    yield call(Api.postReflexAllenOnboardingForm, payload);
  } catch (error) {
    yield put(actions.addError("rl-form-submit", error));
  }
}

export function* getReflexAllenForm({ payload }, count = 0) {
  try {
    yield put(actions.setDownloadingReflexAllenPdf(payload, true));
    const response = yield call(Api.getReflexAllenPdf, payload);
    if (response.status === 200) {
      yield put(
        actions.setReflexAllenPdf({
          pdfString: response.data,
          formCode: payload,
        })
      );
    } else {
      yield put(actions.addError("rl-form-request", response));
    }
  } catch (err) {
    yield put(actions.addError("rl-form-request", err));
    yield delay(2000);
    if (count < 3) {
      yield call(getReflexAllenForm, { payload }, count + 1);
    }
  } finally {
    yield put(actions.setDownloadingReflexAllenPdf(payload, false));
  }
}

export function* postReflexAllenInductionProgramme({ payload }) {
  try {
    yield call(Api.postReflexAllenInductionProgramme, payload);
  } catch (err) {
    yield put(actions.addError("rl-induction-programme-submit", err));
  }
}
